// extracted by mini-css-extract-plugin
export var legendIndicator = "_c9-1";
export var legendRight = "_c9-0";